import React from "react";
import { CategoryEnhancedGridResult } from "~/common/Store/models/Category";
import Carousel from "./Carousel";
import { CarouselOptions } from "./Carousel/props";
const EnhancedGrid = (enhancedGrid: CategoryEnhancedGridResult) => {
  const backgroundColor = enhancedGrid.showBackground ? "gray" : "white";
  const config: CarouselOptions = {
    backgroundColor: enhancedGrid.useAlternateLayout ? "navy" : backgroundColor,
    padding: true,
    sections: enhancedGrid.sections,
    testId: "EnhancedGridCarousel",
    template: enhancedGrid.template,
    name: enhancedGrid.description,
    showDescriptions: enhancedGrid.showDescriptions,
    useAlternateLayout: enhancedGrid.useAlternateLayout
  };
  return <Carousel {...config} data-sentry-element="Carousel" data-sentry-component="EnhancedGrid" data-sentry-source-file="EnhancedGrid.tsx" />;
};
export default EnhancedGrid;